import 'images/home/device-with-pods.png';
import 'images/home/video-poster.jpg';
import 'styles/pages/home';

import VideoTestimonials from 'common/video_testimonials';
import { initializeShopNowModal } from 'pages/home/shop-now-modal';

class Homepage {
  constructor() {
    this.videoHero = new VideoHero();

    this.initializeBodyContent();
    this.initializeHeroPeeker();
    this.initializeShopNowButton();
    this.initializeVideoTestimonials();
    initializeShopNowModal();
  }

  initializeBodyContent() {
    const body = document.querySelector('.body__content');
    body.classList.remove('blue-gradient-background');
  }

  initializeHeroPeeker() {
    this.heroPeekerEl = document.getElementById('js-hero-peeker');

    if (this.heroPeekerEl) {
      window.addEventListener('scroll', this.changeHeroPeekerScale);
      this.changeHeroPeekerScale();
    }
  }

  initializeShopNowButton() {
    window.addEventListener('scroll', this.handleWindowScroll);
  }

  initializeVideoTestimonials() {
    this.videoTestimonials = new VideoTestimonials();
  }

  changeHeroPeekerScale = () => {
    let scale = 1;
    const scrollHeight = 250;

    if (
      document.documentElement.clientWidth >= 768 &&
      window.scrollY < scrollHeight
    ) {
      this.heroPeekerEl.classList.remove('fullScale');
      scale = 0.9 + 0.1 * window.scrollY / scrollHeight;
    }

    this.heroPeekerEl.classList.add('fullScale');
    this.heroPeekerEl.style.transform = `scale(${scale})`;
  };

  handleWindowScroll = () => {
    this.shopNowButtonEl =
      this.shopNowButtonEl || document.querySelector('.js-shop-now-button');
    this.footerEl = this.footerEl || document.querySelector('.js-footer');

    let buttonToFooterPixels =
      this.footerEl.offsetTop -
      window.scrollY -
      document.documentElement.clientHeight;

    if (this.shopNowButtonEl.style.position !== 'fixed') {
      buttonToFooterPixels -= 2 * this.shopNowButtonEl.clientHeight;
    }

    const position = buttonToFooterPixels > 0 ? 'fixed' : 'initial';
    this.shopNowButtonEl.style.position = position;
  };
}

class VideoHero {
  constructor() {
    this.initializeVideo();

    window.addEventListener('resize', this.initializeVideo);
  }

  initializeVideo = () => {
    if (document.documentElement.clientWidth < 768) {
      return;
    }

    const video = document.querySelector('.js-page-hero-video');

    if (!video) {
      return;
    }

    video.setAttribute('poster', video.dataset.poster);
    video.setAttribute('src', video.dataset.mp4);

    window.removeEventListener('resize', this.initializeVideo);
  };
}

if (document.querySelector('.js-home-page')) {
  new Homepage();
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home.js